<div class="row">
<div class="col s6"><h4 class="card-title">Alert Management</h4></div>
<div class="col s6" *ngIf="_isList"><button (click)="addNewAlert()" class="btn green waves-effect waves-light right" type="button" name="action">Add Alert</button></div>
</div>

<div *ngIf="isLoading">
  <div class="preloader-wrapper big active">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</div>

<div class="row"  *ngIf="_isEdit">
  <div class="input-field col s9"></div>
  <div class="input-field col s3">
    <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mr-2 mb-2' href='#' data-target='ddl_alert' style="min-width:250px; margin-left: 40px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="alertTypeSelected">{{alertTypeSelected}}</span>
    </a>
    <ul id='ddl_alert' class='dropdown-content'>
      <li (click)="alertTypeSelect(rec)" *ngFor="let rec of alertTypes; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec}}</a>
      </li>
    </ul>
  </div>
</div>


<div class="row"  *ngIf="_isNew">
  <div class="input-field col s9"></div>
  <div class="input-field col s3">
    <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mr-2 mb-2' href='#' data-target='ddl_alert' style="min-width:250px; margin-left: 40px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="alertTypeSelected">{{alertTypeSelected}}</span>
    </a>
    <ul id='ddl_alert' class='dropdown-content'>
      <li (click)="alertTypeSelectNew(rec)" *ngFor="let rec of alertTypes; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec}}</a>
      </li>
    </ul>
  </div>
</div>

<div *ngIf="!isLoading">
<div>
  <form class="col s12">
    <div class="row"  *ngIf="_isEdit">
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <select [(ngModel)]="users" name="userDdl" id="userDdl" (change)="onChange();" multiple>
          <option  *ngFor="let rec of pageData.userList; let iRec = index;" [value]="rec.email">{{rec.fullName}}</option>
        </select>
       <label>User</label>
      </div>
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <input [(ngModel)]="alertIndex" id="txtAlertIndex" name="txtAlertIndex" type="number" [readonly]="disabled"/>
        <label for="txtAlertIndex" class="active">AlertIndex</label>
      </div>
    </div>
    <div class="row"  *ngIf="_isEdit">
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <select [(ngModel)]="areaId" name="areaDdl" id="areaDdl"  (change)="onChangeArea();" [disabled]="slDisabled">
          <option *ngFor="let rec of pageData.areas; let iRec = index;" [value]="rec.areaId">{{rec.areaName}}</option>
        </select>
        <label>Area</label>
      </div>
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <input [(ngModel)]="frequencyIndex" id="txtFrequencyIndex" name="txtFrequencyIndex" type="number" [readonly]="disabled"/>
        <label for="txtFrequencyIndex" class="active">FrequencyIndex</label>
      </div>
    </div>
    <div class="row"  *ngIf="_isEdit">
    </div>
    
    <div class="row" *ngIf="_isEdit">
      <div class="row">
        <div class="input-field col s12">
          <button (click)="onSubmit()" class="btn cyan waves-effect waves-light right" type="button" name="action">Update
            <i class="material-icons right">send</i>
          </button>
          <button (click)="cancelEdit()" class="btn cyan lighten-2 waves-effect waves-light right" type="button" name="action" style="margin-right: 2px;">Cancel
          </button>
        </div>
      </div>
    </div>

    <div class="row"  *ngIf="_isNew">
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <select [(ngModel)]="users" name="userDdl" id="userDdl" (change)="onChange();" multiple>
          <option  *ngFor="let rec of pageData.userList; let iRec = index;" [value]="rec.email">{{rec.fullName}}</option>
        </select>
       <label>User</label>
      </div>
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <input [(ngModel)]="alertIndex" id="txtAlertIndex" name="txtAlertIndex" type="number" [readonly]="disabled"/>
        <label for="txtAlertIndex" class="active">AlertIndex</label>
      </div>
    </div>
    <div class="row" *ngIf="_isNew">
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <select [(ngModel)]="areaId" name="areaDdlNew" id="areaDdlNew"  (change)="onChangeArea();" [disabled]="slnDisabled">
          <option *ngFor="let rec of pageData.areas; let iRec = index;" [value]="rec.areaId">{{rec.areaName}}</option>
        </select>
        <label>Area</label>
      </div>
      <div class="input-field col s6">
        <i class="material-icons prefix">account_circle</i>
        <input [(ngModel)]="frequencyIndex" id="txtFrequencyIndex" name="txtFrequencyIndex" type="number" [readonly]="disabled" />
        <label for="txtFrequencyIndex" class="active">FrequencyIndex</label>
      </div>
    </div>

    <div class="row" *ngIf="_isNew">
      <div class="row">
        <div class="input-field col s12">
          <button (click)="save()" class="btn cyan waves-effect waves-light right" type="button" name="action">Submit
            <i class="material-icons right">send</i>
          </button>
          <button (click)="cancelNew()" class="btn cyan lighten-2 waves-effect waves-light right" type="button" name="action" style="margin-right: 2px;">Cancel
          </button>
        </div>
      </div>
    </div>


    <div class="row"  *ngIf="_isList">
      <div class="row">
        <div class="input-field col s12">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th style="width: 20%;" scope="col">Alert Name</th>
                <th style="width: 20%;" scope="col">Area Name</th>
                <th style="width: 30%;" scope="col">Email</th>
                <th style="width: 10%;" scope="col">Alert Index</th>
                <th style="width: 10%;" scope="col">Frequency Index</th>
                <th style="width: 10%;" scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rec of alertListDetail">
                <td>{{rec.alertName}}</td>
                <td>{{rec.areaName}}</td>
                <td>{{rec.emails}}</td>
                <td>{{rec.alertIndex}}</td>
                <td>{{rec.frequencyIndex}}</td>
                <td>
                  <div class="row" style="width: 115px;">
                    <div class="left">
                      <button (click)="editRecord(rec)" class="btn cyan waves-effect waves-light right" title="Edit" type="button" name="action" style="width: 50px;">
                        <i class="material-icons right">edit</i>
                      </button>
                    </div>
                    <div class="right">&nbsp;</div>               
                    
                    <div class="">
                      <button (click)="deleteRecord(rec)" class="btn red waves-effect waves-light right" title="Delete" type="button" name="action" style="width: 50px;">
                        <i class="material-icons right">delete</i>
                      </button>
                    </div>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="input-field col s12">
      
      </div>
      <div class="input-field col s12">
        
      </div>
    </div>
    <div class="row">
      <div class="input-field col s12">
      
      </div>
      <div class="input-field col s12">
        
      </div>
    </div>
    <div class="row">
      <div class="input-field col s12">
      
      </div>
      <div class="input-field col s12">
        
      </div>
    </div>
    <div class="row">
      <div class="input-field col s12">
      
      </div>
      <div class="input-field col s12">
        
      </div>
    </div>
    <div class="row">
      <div class="input-field col s12">
      
      </div>
      <div class="input-field col s12">
        
      </div>
    </div> -->

  </form>
</div>
<!-- <div *ngIf="pageData.viewMode=='LISTdfd'" style="bottom: 50px; right: 19px;" class="fixed-action-btn direction-top">
  <a (click)="userForm(null)" class="btn-floating btn-large gradient-45deg-deep-purple-blue gradient-shadow"><i class="material-icons">add</i></a>
  <ul>
      <li><a href="css-helpers.html" class="btn-floating blue"><i class="material-icons">help_outline</i></a></li>
      <li><a href="cards-extended.html" class="btn-floating green"><i class="material-icons">widgets</i></a></li>
      <li><a href="app-calendar.html" class="btn-floating amber"><i class="material-icons">today</i></a></li>
      <li><a href="app-email.html" class="btn-floating red"><i class="material-icons">mail_outline</i></a></li>
  </ul>
</div> -->
</div>
